import { AppThunk } from '../../../store/rootReducer';
import * as ecgListActions from '../actions/ecg-list.actions';
import * as ecgClient from '../clients/ecg.client';
import {
  currentPageSelector,
  doneSelector,
} from '../selectors/ecg-list.selectors';
import { EcgItem } from '../types/ecg.type';

export const loadNextPage =
  (): AppThunk<Promise<EcgItem[] | null>> => async (dispatch, getState) => {
    const currentPage = currentPageSelector(getState());
    const done = doneSelector(getState());

    if (done) {
      return [];
    }

    const nextItems = await ecgClient.getEcgList({
      page: currentPage + 1,
      diagnostic_by_me: 0,
      delineation_by_me: 0,
    });

    if (nextItems == null || nextItems.length === 0) {
      dispatch(ecgListActions.done({ meta: { history: false } }));
      return [];
    }

    dispatch(
      ecgListActions.loaded({ ecgItems: nextItems, meta: { history: false } }),
    );
    return nextItems;
  };
